export interface ComponentIdentityListSpecification {
	id: number;
	title: string;
	items: unknown;
}

export class ComponentIdentityList {
	public readonly id: number;
	public readonly title: string;
	public readonly items: unknown;

	constructor(spec: ComponentIdentityListSpecification) {
		this.id = spec.id;
		this.title = spec.title;
		this.items = spec.items;
	}
}
